// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__GA6Ut","alertIcon":"ConfirmModal_alertIcon__2JPpA"};